import { useContext } from "react";

import { AuthContext } from "../context/auth";

export default function useAuth() {
  const context = useContext(AuthContext);

  return {
    user: context.user,
    setUser: context.setUser,
    getUser: context.getUser,
    updateUser: context.updateUser,
    signInWithGoogle: context.signInWithGoogle,
    createUserWithEmail: context.createUserWithEmail,
    signInWithEmail: context.signInWithEmail,
    signInWithApple: context.signInWithApple,
    signOut: context.signOut,
  };
}
